export const getWindowHeight = w => {
  let windowObj = w || global.window;
  if (windowObj) {
    return windowObj.innerHeight;
  }
};

export const getWindowWidth = w => {
  let windowObj = w || global.window;
  if (windowObj) {
    return windowObj.innerWidth;
  }
};

export const getWindowScrollY = w => {
  let windowObj = w || global.window;
  if (windowObj) {
    return windowObj.scrollY;
  }
};
